<section
    class="md-listing-search broker"
    :class="{ onlymap: onlyMap, compose: composeLayout }"
    v-if="fetchedSearchData && listingSourceReady"
    :style="!isMobileSize && style"
    ref="searchBar"
>
    <!-- mobile search  start-->
    <div
        v-if="isMobile"
        v-sticky="
            isListingPage && !(mapCondition && mapCondition.mapRadius)
                ? { class: 'fixed' }
                : false
        "
        :class="{ 'mobile-sticky': isMobileSize }"
    >
        <div
            class="search-mobile"
            :class="searchBarOnly ? 'search-bar' : ''"
        >
            <!-- input  part  start -->
            <div
                class="input-container"
                v-show="showLocation"
                @click="showKeywordSearch"
            >
                <!--  alone searchbar  Click the magnifying glass to search  -->
                <template
                    v-if="searchBarOnly && !hideSearchBtn && !locationOnly"
                >
                    <div class="search-wrap" @click="submitSearch">
                        <span class="iconfont icon-search"></span>
                    </div>
                </template>
                <!--  not alone searchbar no click event  -->
                <template v-else>
                    <div class="search-wrap">
                        <span class="iconfont icon-search"></span>
                    </div>
                </template>
                <input readonly :placeholder="searchTagCount > 0 ? '' : keywordPlaceholders" />
                <!--  Chosen suggestion exist input displayed in  tag start  -->
                <component :is="searchTag" @update="changeTag" :collapse="true" :simple="true" :filter="['mapPath', 'mapSearch', 'key', 'mapRadius']" />
                <!--  Chosen suggestion exist input displayed in  tag end  -->
            </div>

            <div
                v-if="isMobile && !locationOnly"
                @click="showSearch"
                class="button-layout mode no-button-layout"
            >
                <span
                    class="mode_desc"
                    :class="{ 'no-margin': !filterCount }"
                    >{{ $t('md-search-bar.filters') }}</span
                >
                <span class="squar" v-if="filterCount">{{
                    filterCount
                }}</span>
            </div>

            <div
                class="keyword-search"
                v-if="isReallyUser"
                v-show="isKeywordSearchVisible"
            >
                <component
                    :is="searchCom"
                    :ref="onKeywordSearchRef"
                    :keywordOnly="true"
                    :keywordsPlaceholder="keywordsPlaceholder"
                    @close="hideKeywordSearch"
                />
            </div>
            <!-- autocomplete suggestion list end -->
        </div>
    </div>
    <!-- mobile search  end-->

    <!-- isReallyUser for lighthouse -->
    <!-- mobile search modal -->
    <div :class="'search-content f-col' + (show ? ' show' : '') + (moreDisplayNone ? ' more-display-none': '')">
        <div class="header">
            <span
                class="back iconfont icon-prev"
                @click="hideSearchFn"
            ></span>
            <span
                class="filters"
                @touchstart.prevent
                @touchmove.prevent
                >{{ $t('md-search-bar.filters') }}</span
            >
            <span class="reset" @click="reset">
                <em class="iconfont icon-reset"></em
                >{{ $t('md-search-bar.reset') }}</span
            >
        </div>
        <div class="scroll-zone">
            <component
                :is="searchCom"
                ref="searchMore"
                :keywordsPlaceholder="keywordsPlaceholder"
                @open="showKeywordSearchInMore"
            />
        </div>
        <div class="oper-btns">
            <div
                class="btn save-search"
                :class="filterCount === 0 ? 'disabled' : ''"
                @click="saveSearch"
                v-if="
                    !hideSearchBtn &&
                    listingType !== 'sold-listing' &&
                    !widget
                "
            >
                <em class="iconfont icon-heart-fill"></em
                >{{
                    $t('md-search-bar.saveSearchFiltercount', {
                        count: filterCount
                    })
                }}
                <div class="save-alert-box" v-show="showSaveAlert">
                    {{ $t('md-search-bar.saveYourSearchToGet') }}
                </div>
            </div>
            <!-- snapshot  Show fixed copy in  View Results -->
            <div
                class="btn save-search"
                v-if="
                    (hideSearchBtn || listingType == 'sold-listing') &&
                    !widget
                "
                :class="!snapshotAbled ? 'disabled' : ''"
                @click="clickSaveSnapshot"
            >
                {{ $t('md-search-bar.saveSnapshot') }}
            </div>
            <div
                v-if="!hideSearchBtn"
                class="btn more-search"
                @click="clickMoreSearch"
            >
                <em class="iconfont icon-house-fill"></em
                >{{
                    $t('md-search-bar.property', {
                        count: count,
                        countStr: formatCount
                    })
                }}
            </div>
            <div
                v-if="hideSearchBtn"
                class="btn more-search"
                @click="clickMoreSearch"
            >
                <em class="iconfont icon-house-fill"></em
                >{{ $t('md-search-bar.viewResults') }}
            </div>
        </div>
    </div>

    <!-- search area -->
    <div
        v-show="showLayoutToggle"
        class="search-area"
        @click="switchLayout('map')"
    >
        <div class="map">
            <i class="iconfont icon-search-map"></i>
            <span>{{ $t('md-search-bar.map') }}</span>
        </div>
    </div>
</section>